import { useState } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputTime from "../../helpers/InputTime";
import { Link } from "react-router-dom";


function XTime(props)
{
       
    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [view,setView] = useState('link');


    const [orgHour, setOrgHour] = useState(props.hour);
    const [orgMinute, setOrgMinute] = useState(props.minute);

    const [row, setRow] = useState({
        hm: props.hour + ":" + props.minute,               
    });

 

    const [title, setTitle] = useState(props.title);

  
 

    const valChangeListener = (filedName, val, correct, msg) => {

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }  




    const goChange = () => {
        setView("dialog");    
    }
    

    const closeDialog = () => {

        setRow( {...row, ['hm']: props.hour + ":" + props.minute ,  ["hm_valid"]:true } );  

        setView('link');
        console.log("goclose ");
    }




    const saveTab = () => {

            setView('link');
            console.log("goclose ");

            if(props.onChange != undefined)
                {
                    props.onChange(
                        row.hm,
                        props.param1,
                        props.param2,
                        props.param3,
                        props.param4
                    );
                }

    }


 
 
 


    if(props.hour != orgHour || props.minute != orgMinute)
    {
        setOrgHour(props.hour);
        setOrgMinute(props.minute);
        setRow( {
            hm: props.hour + ":" + props.minute,               
        });
    }


    var dlg = null;

    if(view == 'dialog')
        {
           

            dlg = <div className="dlg_window dlg_type_y">
                    <div className="dlg_title">{title}</div>            

                    <div className="dlg_msg">
                        
                        
                        <div>
                           
                        </div>

                            <div className="form_tab">                                

                                <div className="form_control">
                                    <div className="fieldName">Ustaw nową wartość</div>
                                    <InputTime   userData={props.userData} value={row.hm} err={errTab}  valChange={valChangeListener}  name="hm" placeholder={"Godzin: "} className=' w150 ' req='1'   />
                                </div>

                               

                            </div>


                    </div>

                    <div className="dlg_btn">
                          <div className="btn" atr-type="save" onClick={saveTab}>Zapisz</div>
                          &nbsp;&nbsp;
                          <div className="btn" atr-type="cancel" onClick={closeDialog}>Anuluj</div>
                    </div>
            </div>
        }


 
    return (
        <span>            
             <span onClick={goChange}>{row.hm}*</span>
             {dlg}
        </span>
    )
}

export default XTime;
